<template>
    <v-layout>
        <v-flex xs10 lg8 offset-xs1 offset-lg2>
            <v-form ref="form" @submit.prevent="submit">
                <v-card class="pa-3">
                    <div class="subheading mb-3">{{ $t('label.filters') }}</div>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.reference') }}*</label>
                        </v-flex>
                        <v-flex xs2 lg2>
                             <div>
                                <v-text-field v-if="disabled || readonly" v-model="formatted" :disabled="disabled" class="input-group--date-text-field"></v-text-field>
                                <v-menu v-if="!disabled && !readonly" :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y full-width :nudge-top="20" max-width="290px" style="cursor:arrow">
                                    <v-text-field slot="activator" v-model="date"  style="pointer-events: none;" :rules="validation.required"></v-text-field>
                                    <v-date-picker v-model="date" type="month" no-title show-current="true" locale="pt" @input="menu2 = false"></v-date-picker>
                                </v-menu>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.contract') }}*</label>
                        </v-flex>
                        <v-flex xs9 lg10>
                            <v-select autocomplete v-bind:items="contracts" v-model="form.contractId" clearable :no-data-text="$t('message.warning.noData')" :maxlength="constants.LENGTH_CONTRACT" :rules="validation.required"></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.contractItem') }}</label>
                        </v-flex>
                        <v-flex xs7 lg6>
                            <v-select autocomplete :disabled="!this.form.contractId" v-bind:items="contractItems" v-model="form.contractItemId" :no-data-text="$t('message.warning.noData')" :maxlength="constants.LENGTH_CONTRACT_ITEM"></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.system') }}</label>
                        </v-flex>
                        <v-flex xs9 lg10>
                            <v-select autocomplete :disabled="!this.form.contractItemId" v-bind:items="systems" v-model="form.systemId" :no-data-text="$t('message.warning.noData')"></v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout row>
                        <v-flex xs9 lg10>
                            <v-btn :disabled="creatingReport" @click="clear" class="ma-0">
                                    {{ $t('label.clear') }}
                                </v-btn>

                        </v-flex>
                        <v-flex xs9 lg10>
                            <v-btn :disabled="creatingReport" :loading="creatingReport" @click="createReport" class="ma-0" color="primary">
                                PDF
                            </v-btn>
                            <v-btn :disabled="creatingReport" :loading="creatingReport" @click="createCsvReport" class="ma-0" color="secondary">
                                CSV
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';
import DemandBilling from '@/helpers/entities/DemandBilling';

export default {
    data() {
        return {
            constants,
            validation,
            creatingReport: false,
            date: null,
            form: DemandBilling.build(),
        };
    },

    computed: {
        contracts() {
            return utilities.combobox(
                this.$store.getters.contractsValueText,
                this.form.contractId,
            );
        },
        contractItems() {
            return this.$store.getters.contractItemsValueText.filter(
                item => item.contractId === this.form.contractId,
            );
        },

        systems() {
            return this.$store.getters.activeSystemsValueText.filter(
                item => item.contractItemId === this.form.contractItemId,
            );
            // return this.$store.getters.activeSystemsValueText;
        },
    },
    watch: {
        date() {
            this.form.reference = this.formatReference(this.date);
        },
    },

    methods: {
        clear() {
            this.date = null;
            this.form = DemandBilling.build();
        },
        formatReference(date) {
            if (!date) return null;
            const [year, month] = date.split('-');
            return year + month;
        },

        createReport() {
            if (!this.$refs.form.validate()) return;
            this.creatingReport = true;
            const reportName = 'RelatorioFaturamento';
            this.ajaxDownload('application/pdf', reportName);
        },

        createCsvReport() {
            if (!this.$refs.form.validate()) return;
            this.creatingReport = true;
            const reportName = 'RelatorioFaturamento.csv';
            this.ajaxCsvDownload('application/csv', reportName);
        },

        ajaxDownload(type, name) {
            const xhr = new XMLHttpRequest();
            const url = process.env.API_URL;
            const reportUrl = '/reports/demandBilling';
            const self = this;
            xhr.open('POST', url + reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/pdf');
            xhr.responseType = 'arraybuffer';
            xhr.send(JSON.stringify(DemandBilling.toPayload(this.form)));
            xhr.onprogress = this.callback;
            xhr.onload = function onload() {
                if (this.status === 200) {
                    const blob = new Blob([this.response], { type });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
            self.creatingReport = false;
        },

        ajaxCsvDownload(type, name) {
            const xhr = new XMLHttpRequest();
            const url = process.env.API_URL;
            const reportUrl = '/reports/demandBillingCsv';
            xhr.open('POST', url + reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/csv');
            xhr.responseType = 'arraybuffer';
            xhr.send(JSON.stringify(DemandBilling.toPayload(this.form)));
            xhr.onprogress = this.callback;
            xhr.onload = function onload() {
                if (this.status === 200) {
                    const blob = new Blob([this.response], { type });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
            this.creatingReport = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/DemandBilling.vue